import { Badge, ToggleButton, Tooltip } from "@mui/material";
import {
  Star as StarIcon,
  StarBorder as StarBorderIcon,
} from "@mui/icons-material";
import { motion } from "framer-motion";
import { useState } from "react";
import { fetchDirectories } from "../../store/slices/filesSlice.js";
import { useDispatch } from "react-redux";
import {
  setCurrentFolder,
  setBreadcrumbs,
} from "../../store/slices/filesSlice.js";

const FavoritesButton = ({
  files,
  currentFolder,
  showFavoritesOnly,
  setShowFavoritesOnly,
  handleFavoritesClick,
}) => {
  const dispatch = useDispatch();
  // Track whether we're currently showing favorites
  const handleClick = () => {
    // Reset navigation state when toggling
    dispatch(setCurrentFolder(null));
    dispatch(setBreadcrumbs([]));
    handleFavoritesClick();
  };
  // Count favorited items recursively
  const countFavorites = (nodes) => {
    if (!nodes || !Array.isArray(nodes)) return 0;
    let count = 0;
    nodes.forEach((node) => {
      if (node.starred === true) {
        count++;
      }
      if (node.children && Array.isArray(node.children)) {
        count += countFavorites(node.children);
      }
    });
    return count;
  };

  const favoritesCount = countFavorites(files || []);

  return (
    <>
      {/* Favorites Filter Toggle (Material Design 3) */}
      <Tooltip
        title={showFavoritesOnly ? "Show all files" : "Show favorites only"}
      >
        <Badge
          badgeContent={favoritesCount}
          color="primary"
          sx={{
            "& .MuiBadge-badge": {
              fontFamily: "Roboto, sans-serif",
              fontSize: "10px",
              fontWeight: 500,
              height: 16,
              minWidth: 16,
              padding: "0 4px",
            },
          }}
        >
          <ToggleButton
            value="favorites"
            selected={showFavoritesOnly}
            onChange={handleClick}
            size="small"
            aria-label={
              showFavoritesOnly ? "Show all files" : "Show favorites only"
            }
            aria-pressed={showFavoritesOnly}
            sx={{
              width: 36,
              height: 36,
              border: "1px solid #E5E7EB",
              borderRadius: "4px",
              color: showFavoritesOnly ? "#FF8555" : "#4A5565",
              bgcolor: showFavoritesOnly ? "#FFE0D0" : "white",
              transition: "all 0.15s ease-out",
              "&:hover": {
                bgcolor: showFavoritesOnly ? "#FFD0B8" : "#F2F2F2",
                borderColor: showFavoritesOnly ? "#FF8555" : "#2932E5",
              },
              "&.Mui-selected": {
                bgcolor: "#FFE0D0",
                borderColor: "#FF8555",
                color: "#FF8555",
                "&:hover": {
                  bgcolor: "#FFD0B8",
                },
              },
              "&.MuiButtonBase-root-MuiToggleButton-root": {
                lineHeight: "0 !important",
              },
            }}
          >
            <motion.div
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
              transition={{ duration: 0.15 }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
              }}
            >
              {showFavoritesOnly ? (
                <StarIcon sx={{ fontSize: 20, display: "flex" }} />
              ) : (
                <StarBorderIcon sx={{ fontSize: 20, display: "flex" }} />
              )}
            </motion.div>
          </ToggleButton>
        </Badge>
      </Tooltip>
    </>
  );
};

export default FavoritesButton;
